'use strict';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import Loader from '../../Loader';
import OTButton from '../../tag/OTButton';
import OTButtonGroup from '../../tag/OTButtonGroup';
import WindowUtils from '../../../utils/WindowUtils';

const { id: module_id } = module;

class AgreementPage2 extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.getElementById('skip-to-content').focus();
  }

  cancel = (event) => {
    event.preventDefault();
    this.props.triggerCancelModal();
  };

  next = () => {
    WindowUtils.navigate('#/3');
  };

  render() {
    let { userInfo } = this.props;

    if (!userInfo) {
      return <Loader />;
    }

    return (
      <div className="ot-agreement-page">
        <h1 className="ot-agreement-title">
          <FormattedMessage
            id={`${module_id}.title`}
            values={{ name: this.props.userInfo.wholeName }}
          />
        </h1>
        <br />
        <div className="row-fluid text-center infotext">
          <div className="span12">
            <p>
              <FormattedMessage
                id={`${module_id}.infotext1`}
                values={{
                  strong: (chunk) => <strong>{chunk}</strong>,
                }}
              />
            </p>
          </div>
        </div>
        <div className="row-fluid text-center">
          {/* graph of the agreement */}
          <div className="graph ">
            <div className="graph__item">
              <div className="graph__item__ball">
                <span className="graph__item__ball__num">1</span>
              </div>
              <div className="graph__item__label">
                <FormattedMessage id={`${module_id}.graphtext1`} />
              </div>
            </div>
            <div className="graph__item">
              <div className="graph__item__ball">
                <span className="graph__item__ball__num">2</span>
              </div>
              <div className="graph__item__label">
                <FormattedMessage id={`${module_id}.graphtext2`} />
              </div>
            </div>
            <div className="graph__item">
              <div className="graph__item__ball">
                <span className="graph__item__ball__num">3</span>
              </div>
              <div className="graph__item__label">
                <FormattedMessage id={`${module_id}.graphtext3`} />
              </div>
            </div>
          </div>
        </div>
        <div className="row-fluid text-center infotext">
          <div className="span12">
            <p>
              <FormattedMessage id={`${module_id}.infotext2`} />
            </p>
          </div>
        </div>
        <br />
        <div className="ot-agreement-buttons row-fluid text-center">
          <OTButtonGroup fullWidth type={'big'} expectedCount={2}>
            <OTButton onClick={this.cancel}>
              <FormattedMessage id={'abort'} />
            </OTButton>
            <OTButton onClick={this.next}>
              <FormattedMessage id={'continue'} />
            </OTButton>
          </OTButtonGroup>
        </div>
      </div>
    );
  }
}

export default AgreementPage2;
